import dateFormat from "dateformat";
import { convertToMonthsAndDays } from "../../../dates";

export const monitoringValueMappers = {
  is_repayment_amount: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_loan_documentation_provided: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_fullfilled_used_amount: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_deadline_approve: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_new_deadline_approved: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_female_entrepreneur: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_mountain_region: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_income_to_k: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_sun_gate_beneficiary: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_female_entrepreneur_checked: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_mountain_region_checked: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_income_to_k_checked: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_sun_gate_beneficiary_checked: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_purchased_activities_checked: (isTruthy: boolean) => (isTruthy ? "არა" : "კი"),
  is_project_activities_checked: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  is_purpose_detailed_provided: (isTruthy: boolean) => (isTruthy ? "კი" : "არა"),
  contract_signed_date: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy") : ""),
  start_activity_date: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy") : ""),
  cgs_created_at: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy") : ""),
  monitoring_new_deadline: (date: string) => (date ? dateFormat(date, "dd/mm/yyyy") : ""),
  unfulfilled_used_amount_month_day: (millisecconds: number) => {
    const { months, days } = convertToMonthsAndDays(millisecconds);
    return `${months ? months : 0} თვე,  ${days ? days : 0} დღე`;
  },
  is_taken_business_loan_leasing: (isTruthy: boolean | undefined) => (typeof isTruthy === "undefined" ? "უცნობი" : isTruthy ? "კი" : "არა"),
};
